import {GLOBALS} from "../config/env";

export const SubmitCovidResponse = (answers, updateResponse) => async () => {
    const {url,apiKey} =  GLOBALS.config.covidService;
    const {store,associateName,covidSymptomsYesNo,contactYesNo,
        lastTimeInStore,listOfPeopleInContact } = answers;
    if(answers && answers.store && answers.associateName){

        const post = {
            "name":  associateName,
            "storeNumber":  store,
            "covidSymptoms": covidSymptomsYesNo === "covidSymptomsYes" ? "Yes" : "No",
            "lastTimeInStore": lastTimeInStore,
            "peopleInContact": listOfPeopleInContact? answers.replaceAll("\n") : "",
            "status":  contactYesNo === "contactYes" ? "Yes" : "No"
        }

        postData(url + "/ebs/postcoviddata",post, apiKey).then(res => {
            if(res && res.status === 201){
                console.log("Request submitted :" + JSON.stringify(res));
                updateResponse(prevState => ({...prevState, status : "Success"}));
            }
            else{
                console.log("Submission error " + JSON.stringify(res))
                updateResponse(prevState => ({...prevState, status : "Error:" + JSON.stringify(res)}));
            }
        }).catch(e => {
            console.log("Submission error " + e)
            updateResponse(prevState => ({...prevState, status : "Failure:" + e}));
        })
    }
}


async function postData(url, data, apiKey) {
    //console.log("post data " + url + "," + JSON.stringify(data) + "," + apiKey);
    const response = await fetch(url, {
        method: 'POST',
        mode: "cors",
        credentials: "omit",
        headers: {
            'X-Subscription-Key':apiKey,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    });
    return response;
}